export enum NotePriority {
  NOT_DEFINE = 'NOT_DEFINE',
  LOW = 'LOW',
  NORMAL = 'NORMAL',
  HIGH = 'HIGH',
  EXPEDITE = 'EXPEDITE',
}
